@import "src/styles/common/_colors.scss";

.searchHighlight {
    background-color: $text-highlight;
    color: $white;
}